<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="autoPriceGradeSetForm" :model="autoPriceGradeSetForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="商户">
              <el-select
                clearable
                v-model="autoPriceGradeSetForm.merchantId"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in merchatOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
             <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="autoPriceGradeSetForm.categoryId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
           <el-form-item label="年代" prop="machineYearId">
              <el-select v-model="autoPriceGradeSetForm.machineYearId">
                <el-option
                  v-for="item in machineYearConfigList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getAutoPriceImageDetectConfigList">查询</el-button>
            <el-button type="primary" @click="addAutoPriceImageDetectConfig">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="merchantName"
            label="商户">
          </el-table-column>
          <el-table-column
            prop="categoryName"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="brandIdListName"
            label="品牌">
          </el-table-column>
          <el-table-column
            prop="machineYearName"
            label="年代">
          </el-table-column>
          <el-table-column
            prop="modelIdListName"
            show-overflow-tooltip
            label="机型">
          </el-table-column>
          <el-table-column
            prop="gradeIdListName"
            show-overflow-tooltip
            label="前端等级区间">
          </el-table-column>
          <el-table-column
            prop="gradeName"
            label="出价等级">
          </el-table-column>
          <el-table-column
            prop="limitPrice"
            label="限制价格">
          </el-table-column>
          <el-table-column
            prop="accessDeductionOptionFlag"
            label="是否接入扣款">
            <template slot-scope="scope">
              <span v-if="scope.row.accessDeductionOptionFlag === 0">否</span>
              <span v-else>是</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">已启用</span>
              <span v-else>已关闭</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorAutoPriceImageDetectConfig(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="open(scope.row.id)" type="text" size="small" v-if="scope.row.status === 1">开启</el-button>
                <el-button @click="close(scope.row.id)" type="text" size="small" style="color: red;" v-else>关闭</el-button>
                <el-button @click="deleteAutoPriceImageDetectConfig(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button>
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑AI自动出价' : '新建AI自动出价'" :visible.sync="isDlg" width="900px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editAutoPriceGradeSetForm" :model="editAutoPriceGradeSetForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="ID" v-if="dlgType === 'change'">
              <el-input clearable v-model="editAutoPriceGradeSetForm.id" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="商户">
              <el-select clearable
                v-model="editAutoPriceGradeSetForm.merchantId"
                filterable
                remote
                placeholder="请输入关键词"
                reserve-keyword>
                <el-option
                  v-for="item in merchatOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分类" prop="categoryId">
              <el-select v-model="editAutoPriceGradeSetForm.categoryId" @change="getGradeList(true)">
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌" prop="tempBrandIdList">
              <el-select
                    clearable
                    style="width:100%"
                    v-model="tempBrandIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in brandOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>
             <el-form-item label="年代" prop="machineYearId">
              <el-select v-model="editAutoPriceGradeSetForm.machineYearId" @change="getModelListByBrandIds()">
                <el-option
                  v-for="item in machineYearConfigList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机型" prop="tempModelIdList">
              <el-select
                    clearable
                    style="width:100%"
                    v-model="tempModelIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in modelList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>
            <el-form-item label="前端等级区间" prop="tempGradeIdList">
              <el-select
                    clearable
                    style="width:100%"
                    v-model="tempGradeIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in queryGradeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>
            <el-form-item label="出价等级" prop="gradeId">
              <el-select
                    clearable
                    style="width:100%"
                    v-model="editAutoPriceGradeSetForm.gradeId"
                    filterable
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in queryGradeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>
            <el-form-item label="限制价格" prop="limitPrice">
              <el-input v-model="editAutoPriceGradeSetForm.limitPrice"></el-input>
            </el-form-item>
              <el-form-item label="是否接入扣款" prop="accessDeductionOptionFlag">
                <el-radio v-model="editAutoPriceGradeSetForm.accessDeductionOptionFlag" :label="0">否</el-radio>
                <el-radio v-model="editAutoPriceGradeSetForm.accessDeductionOptionFlag" :label="1">是</el-radio>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import MachineYearConfig from '../machineYearConfig/machineYearConfig.vue';

export default {
  components:{},
  props:{},
  data(){
    return {
      dispatchOrderRoleTypeList:[{'id':1,'name':'报价员'},{'id':2,'name':'机器人'}],
      // 查询数据
      autoPriceGradeSetForm: {
        categoryId: null
      },
      categoryOptions: [],
      priceRuleCombProject:[{
        priceStart: null,
        priceEnd: null,
        gradeId: null,
        timeLimit: null,
        limitPrice:null
      }],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      tempGradeIdList:[],
      tempBrandIdList:[],
      tempModelIdList:[],

      // 新建编辑对话框数据

      isDlg: false,
      editAutoPriceGradeSetForm: {
        id: null,
        categoryId: null,
        gradeIdList: [],
        autoPriceGradeId: null,
        accessDeductionOptionFlag: 0
      },

      editorFormRules: {
        categoryId: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ],
        // tempGradeIdList: [
        //   { required: true, message: '请选择前端等级', trigger: 'change' },
        // ],
      },
      dlgType: 'change',
      queryGradeList:[],
      brandOptions:[],
      modelList:[],
      merchatOptions:[],
      machineYearConfigList:[],
    }
  },
  watch:{},
  computed:{},
  methods:{
      // 请求几代机配置
     getMachineYearConfigList(param) {
      let self = this;
      self.$api.listMachineYearConfig().then(res => {
        if(res.code === 200) {
          self.machineYearConfigList = res.data || []
        }
      
      })
    },
     // 请求商户列表
     getMerchantList(param) {
      let self = this;
      self.$api.getMerchantList({
        merchantLike: param,
        page: 1,
        size: 100000,
      }).then(res => {
        if(res.code === 200) {
          self.merchatOptions = res.data.records
          self.merchatOptions.unshift({'id':0,'name':'通用'})
        }
      
      })
    },
        //获取品牌下的sku信息
    getModelListByBrandIds() {
       let self = this;
       let machineYearConfig = null;
       for(var i = 0;i<self.machineYearConfigList.length;i++){
         let temp = self.machineYearConfigList[i]
         if(temp.id==self.editAutoPriceGradeSetForm.machineYearId){
           machineYearConfig = temp;
           break;
         }
       }

      self.$api
        .getModelListByBrandIds({
          brandIds: self.tempBrandIdList,
          startYear: machineYearConfig==null?null:machineYearConfig.startYear,
          endYear: machineYearConfig==null?null:machineYearConfig.endYear
        })
        .then((res) => {
          self.modelList = res.data;
          self.modelList.unshift({'id':0,'name':'通用'})
        });
    },
    initPriceRule(priceRule){
      var temp = JSON.parse(priceRule)
      if(temp!=null){
        var str="";
        for(var i=0;i<temp.length;i++){
          str =str+"["+temp[i].priceStart+"-"+temp[i].priceEnd+","+temp[i].timeLimit+","+temp[i].gradeName+","+temp[i].limitPrice+","+temp[i].dispatchOrderRoleTypeName+"]"+";" 
      }
      return str
      }
      return ''
    },
    deletePriceRuleItem(itemIndex){
      let self = this
      this.priceRuleCombProject.splice(itemIndex,1);
      self.isRefresh = false;
        this.$nextTick(() => {
          self.isRefresh = true;
        });
    },
    addCondition() {
      this.priceRuleCombProject.push({
        priceStart: null,
        priceEnd: null,
        gradeId: null,
        timeLimit:null,
        limitPrice:null
       });
    },
    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
            if(optionName=='brandOptions'){
              self[optionName].unshift({'id':0,'name':'通用'})
            }
          }
        });
    },
    deleteAutoPriceImageDetectConfig(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteAutoPriceImageDetectConfig({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getAutoPriceImageDetectConfigList()
          }
      })
      })
   
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },

    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getAutoPriceImageDetectConfigList()
    }, 
    //等级
    getGradeList(val) {
      let self = this;
        this.$api
            .getValidModelGrade({
              categoryId: self.editAutoPriceGradeSetForm.categoryId,
            })
            .then((res) => {
              self.queryGradeList = res.data || [];
             
            });
          if(val){
            self.tempGradeIdList=[];
            self.tempBrandIdList=[];
            self.tempModelIdList=[];
            self.editAutoPriceGradeSetForm.autoPriceGradeId=null;
          }
          self.getSelectOptions(
                    'phoneBrand',
                    'brandOptions',
                    self.editAutoPriceGradeSetForm.categoryId
                  ); 
    },

    // 获取门店列表
    getAutoPriceImageDetectConfigList() {
      let self  = this;
      self.$api.listSearchAutoPriceImageDetectConfig({
        page: self.currentPage,
        size: self.pageSize,
        merchantId: self.autoPriceGradeSetForm.merchantId,
        categoryId: self.autoPriceGradeSetForm.categoryId || null,
        machineYearId:self.autoPriceGradeSetForm.machineYearId || null
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加门店
    addAutoPriceImageDetectConfig() {
      this.dlgType = 'new'
      this.tempGradeIdList=[];
      this.tempBrandIdList=[]
      this.tempModelIdList=[]
      this.priceRuleCombProject=[{}]
      this.editAutoPriceGradeSetForm =  {
        id: null,
        merchantId:null,
        categoryId: null,
        gradeIdList: [],
        brandIdList:[],
        modelIdList:[],
        gradeId:null,
        machineYearId:null,
        limitPrice:null,
        accessDeductionOptionFlag: 0
      }
      this.$nextTick(()=>{
          this.$refs['editAutoPriceGradeSetForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改门店
    editorAutoPriceImageDetectConfig(row) {
      let self = this;
      self.editAutoPriceGradeSetForm=JSON.parse(JSON.stringify(row));
      self.getGradeList(false);
      self.tempGradeIdList = JSON.parse(self.editAutoPriceGradeSetForm.gradeIdList)
      self.tempBrandIdList = JSON.parse(self.editAutoPriceGradeSetForm.brandIdList)
      self.tempModelIdList = JSON.parse(self.editAutoPriceGradeSetForm.modelIdList)
      self.getModelListByBrandIds()
      self.dlgType = 'change'
      this.$nextTick(()=>{
        self.isDlg = true
      })
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editAutoPriceGradeSetForm'].validate((valid) => {
        if (valid) {
          self.editAutoPriceGradeSetForm.gradeIdList=JSON.stringify(self.tempGradeIdList);
          self.editAutoPriceGradeSetForm.brandIdList=JSON.stringify(self.tempBrandIdList);
          self.editAutoPriceGradeSetForm.modelIdList=JSON.stringify(self.tempModelIdList);
          if(self.dlgType === 'change') {
            self.$api.updateAutoPriceImageDetectConfig(self.editAutoPriceGradeSetForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getAutoPriceImageDetectConfigList()
                this.closeEditorDlg()
              }
            })
          } else {
            self.$api.addAutoPriceImageDetectConfig(self.editAutoPriceGradeSetForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getAutoPriceImageDetectConfigList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

    //获取等级名称
    getGradeName(gradeId){
      for(var i=0;i<this.queryGradeList.length;i++){
        if(gradeId==this.queryGradeList[i].id){
          return this.queryGradeList[i].name
        }
      }
      return ""
    },
      //获取等级名称
      getDispatchOrderWayTypeName(id){
      for(var i=0;i<this.dispatchOrderRoleTypeList.length;i++){
        if(id==this.dispatchOrderRoleTypeList[i].id){
          return this.dispatchOrderRoleTypeList[i].name
        }
      }
      return ""
    },

    // 开启门店
    open(id) {
      let self = this
      this.$api.openAutoPriceImageDetectConfig(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '开启成功',
            type: 'success'
          });
          self.getAutoPriceImageDetectConfigList()
        }
      })
    },

    // 关闭门店
    close(id) {
      let self = this
      this.$api.closeAutoPriceImageDetectConfig(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
          self.getAutoPriceImageDetectConfigList()
        }
      })
    },

  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getAutoPriceImageDetectConfigList();
    self.getSelectOptions("category", "categoryOptions");
    self.getMerchantList();
    self.getMachineYearConfigList()
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>